import duchengjun from './members/duchengjun.jpg'
import liuyuxuan from './members/liuyuxuan.jpg'
import caiwenzhen from './members/caiwenzhen.jpg'
import chenruijia from './members/chenruijia.jpeg'
import liangyating from './members/liangyating.jpg'
import wangxinling from './members/wangxinling.jpg'
import keyijie from './members/keyijie.jpg'
import linyunxiu from './members/linyunxiu.jpg'
import wangyuwen from './members/wangyuwen.jpeg'
import jiangmingdi from './members/jiangmingdi.jpg'
import yanglingxuan from './members/yanglingxuan.jpg'
import jianyongqing from './members/jianyongqing.jpg'
import xutingyu from './members/xutingyu.jpg'
import xiaoxinyu from './members/xiaoxinyu.jpg'
import xiazhenghua from './members/xiazhenghua.jpg'
import chenhongsheng from './members/chenhongsheng.jpg'


export const crew_member = [
    {
        name:'杜承濬',
        title:'策展部',
        image:<img alt="person" src = {duchengjun}/>
    },
    {
        name:'劉于瑄',
        title:'策展部',
        image:<img alt="person" src = {liuyuxuan}/>
    },
    {
        name:'蔡汶蓁',
        title:'​策展部',
        image:<img alt="person" src = {caiwenzhen}/>
    },
    {
        name:'陳睿家',
        title:'​策展部',
        image:<img alt="person" src = {chenruijia}/>
    },
    {
        name:'梁雅婷',
        title:'企銷部',
        image:<img alt="person" src = {liangyating}/>
    },
    {
        name:'王馨璘',
        title:'企銷部',
        image:<img alt="person" src = {wangxinling}/>
    },
    {
        name:'林于綉',
        title:'企銷部',
        image:<img alt="person" src = {linyunxiu}/>
    },
    {
        name:'柯懿婕',
        title:'企銷部',
        image:<img alt="person" src = {keyijie}/>
    },
    {
        name:'王鈺雯',
        title:'企銷部',
        image:<img alt="person" src = {wangyuwen}/>
    },

    {
        name:'江明諦',
        title:'講者部',
        image:<img alt="person" src = {jiangmingdi}/>
    },
    {
        name:'楊苓瑄',
        title:'講者部',
        image:<img alt="person" src = {yanglingxuan}/>
    },
    {
        name:'簡泳晴',
        title:'講者部',
        image:<img alt="person" src = {jianyongqing}/>
    },
    {
        name:'許庭瑜',
        title:'講者部',
        image:<img alt="person" src = {xutingyu}/>
    },
    {
        name:'蕭心瑜',
        title:'設計部',
        image:<img alt="person" src = {xiaoxinyu}/>
    },
    {
        name:'夏震華',
        title:'設計部',
        image:<img alt="person" src = {xiazhenghua}/>
    },
    {
        name:'陳鴻笙',
        title:'設計部',
        image:<img alt="person" src = {chenhongsheng}/>
    },
]  